export { default as EditProduct } from './EditProduct';
